import React from 'react';

const ReclamationIcon = ({ fill, width = 17, height = 16, opacity = 1, ...rest }) => (
    <svg className="icon reclamation-icon" width={width} height={height} viewBox="0 0 17 16" {...rest}>
        <path
            fill={fill}
            fillRule="evenodd"
            d="M14.026 0a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4l-2 2-2-2h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zm0 1h-12a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4a1 1 0 0 1 .707.293l1.293 1.293 1.293-1.293a1 1 0 0 1 .707-.293h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm-6 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1z"
        />
    </svg>
);

export default ReclamationIcon;
